app.controller('previewController', function ($scope,$auth,$state,$location,objectService,questionService) {
    var query = $location.search();
    objectService.setReviewMode(true);

    $scope.loading = true

    function init() {
        objectService.fetchObject().then(function(){
            $scope.loading = false
            $state.go('preloader')
        });
    }

    if(query.object && query.configuration){
        objectService.setPreviewMode(true);
        // Use Satellizer's $auth service to login
        $auth.login({
            preview:       true,
            object:        query.object,
            configuration: query.configuration,
        }).then(init)
    } else {
        init()
    }
});
